import { render, staticRenderFns } from "./children.vue?vue&type=template&id=1b166992&scoped=true&"
import script from "./children.vue?vue&type=script&lang=js&"
export * from "./children.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b166992",
  null
  
)

export default component.exports